<script lang="ts">
  // libs
  import * as LocaleString from "@shared/svelte/Components/DateFormatter/LocaleString.svelte";

  // components
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";

  // types
  import type { Credit } from "@shared/types/Credit";

  // props
  export let credit: Credit;

  // data
  let creditStatusClass = {
    available: "fizz-pill-gray",
    scheduled: "fizz-pill-yellow",
    pending: "fizz-pill-yellow",
    applied: "fizz-pill-green",
    closed: "fizz-pill-black",
  };

  // functions
  const displayStatusType = (credit: Credit): string => {
    return credit.credit_status;
  };
  const viewCredit = (invoiceId: number) =>
    (window.location.href = `/invoices/credits/${invoiceId}`);
  const goToCredit = (event: any, creditId: number) => {
    let target = event.target;
    let skipLabels = ["Distributor", "Due Date", "Status", "Invoice", "Amount"];

    // don't redirect if user clicks on the invoice menu button section
    let targetLabel = skipLabels.includes(target.dataset.label);
    let skipTargetClass = target.classList.contains("popover-list-item");
    if (!targetLabel || skipTargetClass) return;

    viewCredit(creditId);
  };

</script>

<tr
  class="cursor-pointer"
  on:click|preventDefault={e => goToCredit(e, credit.id)}
  id="credit-{credit.id}"
>
  <td data-label="Distributor">{credit.distributor.retailer_facing_name}</td>
  <td data-label="Issue Date">
    <div class="fizz-flex-row-0">
      <span id="issue-date-{credit.id}">
        {LocaleString.convertISODateStringToTimeZoneSafeFormattedLocaleDate(credit.issue_date)}
      </span>
    </div>
  </td>
  <td data-label="Status">
    <span class={creditStatusClass[displayStatusType(credit)]} style="text-transform:capitalize;">
      {displayStatusType(credit)}
    </span>
  </td>
  <td data-label="Invoice">#{credit.invoice_reference_id}</td>
  <td data-label="Amount" class="fizz-align-right">
    <FormatMoney input={credit.original_amount_due} formatType={"5"} />
  </td>
</tr>
